
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";

import {
  CreateOrEditProjectDto,
  OrganizationUnitDto,
  AuditFlowDto
} from "@/api/appService";

import AbSelect from "@/components/AbSelect/index.vue";
import { ElForm } from "element-ui/types/form";

@Component({
  components: { AbSelect }
})
export default class EditProject extends Vue {
  @Ref() readonly dataForm!: ElForm;

  get dialogTitle() {
    return this.form!.id ? "编辑" : "新建";
  }

  async created() {
    await api.organizationUnit.getOrganizationUnits().then(res => {
      this.storesList = res.items!;
    });
  }

  auditFlows: AuditFlowDto[] = [];

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      await api.project.getForEdit({ id: this.form!.id }).then(res => {
        this.form = res.data;
        this.auditFlows = (res.schema as any).auditFlows;
      });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  storesList: OrganizationUnitDto[] = [];

  defaultData: CreateOrEditProjectDto = {
    title: undefined,
    headmanName: undefined,
    headmanPhone: undefined,
    headmanMail: undefined,
    startDate: undefined,
    endDate: undefined,
    totalBudget: undefined,
    organizationUnitId: undefined,
    id: 0
  };

  show = false;
  form: CreateOrEditProjectDto | undefined = { ...this.defaultData };

  async save() {
    console.log(this.form);
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.project.update({ body: this.form });
        } else {
          await api.project.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    auditFlowId: [
      {
        required: true,
        message: "审核流程必选",
        trigger: "blur"
      }
    ],
    title: [
      {
        required: true,
        message: "请输入项目标题",
        trigger: "change"
      }
    ],
    headmanName: [
      {
        required: true,
        message: "请输入负责人姓名",
        trigger: "change"
      }
    ],
    headmanPhone: [
      {
        required: true,
        pattern: /^1[34578]\d{9}$/,
        message: "请输入正确的手机号码",
        trigger: "blur"
      }
    ]
  };
}
